import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import {Badge, IconButton, Tooltip} from '@mui/material';
import {bool, func, number, object, string} from 'prop-types';
import React from 'react';

const FilterMenuButton = ({
  onClick,
  badgeCount,
  tooltipText = '',
  tooltipPlacement,
  disabled,
  sx,
  ...props
}) => {
  const adjustedButtonProps = {
    disabled: disabled,
    component: disabled ? 'div' : undefined,
    onClick: disabled ? undefined : onClick,
  };

  return (
    <Badge
      badgeContent={badgeCount}
      slotProps={{badge: {'aria-label': 'filter count badge'}}}
      color="primary"
    >
      <Tooltip title={tooltipText} placement={tooltipPlacement}>
        <IconButton
          size="small"
          variant="outlined"
          {...props}
          {...adjustedButtonProps}
          sx={[
            {
              '&.Mui-disabled': {
                pointerEvents: 'auto',
              },
              backgroundColor: 'background.paper',
              borderRadius: 1,
              border: 1,
              borderColor: 'divider',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ]}
        >
          <FilterAltOutlinedIcon fontSize="small" color="action" />
        </IconButton>
      </Tooltip>
    </Badge>
  );
};

FilterMenuButton.propTypes = {
  onClick: func,
  badgeCount: number,
  tooltipText: string,
  tooltipPlacement: string,
  disabled: bool,
  sx: object,
};

export default FilterMenuButton;
